import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    API_GTMIntegration,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
let arr = [];
export default function GTMIntegration({ visible, toggle, id,integration, LoadIntegrations }) {    
    const [property, setProperty] = useState([]);
    const [open,setOpen] = useState(false);
    const [msg,setMsg] =useState([]);
    const [maskData, setMaskData] = useState({
        apiKey: "",
        ApiSecret: "",
    });
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: '',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        Tag: '', 
        Script:'',
    });
    useEffect(() => {        
        if (id !== undefined && integration!== undefined) {                   
            AxiosAPI({
                method: 'get',
                url: `${API_GTMIntegration}/${id}?group_id=${getGroupID()}`,
            })
                .then(res => {                    
                    setInputData({
                        ...inputData,
                        Name: res.data.name,
                        Properties: res.data.properties !== null ? res.data.properties : [],
                        Tag: (res.data.googleTagManagerIntegration.tag),                 
                        Script: (res.data.googleTagManagerIntegration.script),                 
                    });

                })
                .catch(err => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
    }, [id]);    

    const handleChange = e => {
        e.persist();
        setInputData({ ...inputData, [e.target.name]: e.target.value });
    };

    
  const handleCheckChange = (e) => {
    let filterList =[];    
    if (inputData.Properties.filter((p)=>p===e.target.value).length>0) {
      filterList=inputData.Properties.filter(f=>f!==e.target.value);
    }
    else{
       filterList=inputData.Properties;
       filterList.push(property.filter((p)=>p.id===e.target.value)[0].id);
    }     
    setInputData({ ...inputData, Properties: filterList });
  };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_GTMIntegration}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        LoadIntegrations();
                    }, 300);
                }
            });

        } else {
            AxiosAPI({
                method: 'post',
                url: API_GTMIntegration,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        LoadIntegrations();
                    }, 300);
                }
            });

        }
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6> {id === undefined ? "Add" : "Update" } Google Tag Manager Intregation</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup>
                                        <Label>Intregation Name</Label>
                                        <Input
                                            type="text"
                                            name="Name"
                                            onChange={handleChange}
                                            placeholder="Intregation Name"
                                            defaultValue={inputData.Name}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Tag</Label>
                                        <Input
                                            type="text"
                                            name="Tag"
                                            onChange={handleChange}
                                            placeholder="Tag"
                                            defaultValue={inputData.Tag}
                                        />
                                    </FormGroup>   
                                    <FormGroup>
                                        <Label>Script</Label>
                                        <Input
                                            type="textarea"
                                            name="Script"
                                            style={{ height: '100px' }}
                                            onChange={handleChange}
                                            placeholder="Script"
                                            defaultValue={inputData.Script}
                                        />
                                    </FormGroup>  
                                                                  
                                    <FormGroup className="mt-3">
                                        <div className='integration-property text-start'>
                                            <div className='row' style={{textAlign:'left'}}>
                                            {property.map((p, index) => {
                                                return (
                                                <div className='col-md-6'>
                                                <CustomInput
                                                   key={p.id}
                                                   type="checkbox"
                                                   id={index}
                                                   value={p.id}
                                                   label={p.name}
                                                   checked={inputData.Properties.filter((f) => p.id === f).length > 0 ? true : false}
                                                   onChange={handleCheckChange}
                                                />
                                                </div>)
                                            })}
                                        </div>
                                    </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (<Button color="primary" size="xs" onClick={handleSave}>
                                        Create New Intregation
                                    </Button>) : (<Button color="primary" size="xs" onClick={handleSave}>
                                        Update Intregation
                                    </Button>)}
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
        </Fragment>
    );
}